export default __webpack_public_path__ + "static/media/warning--pavement-ends--g3.95da7c5c.png";